import { render } from "./Sidebar.vue?vue&type=template&id=728a921c&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=728a921c&scoped=true&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=728a921c&lang=css"
script.render = render
script.__scopeId = "data-v-728a921c"

export default script